<template>
  <div class="contentIconBack">
    <svg xmlns="http://www.w3.org/2000/svg"
         :width="width"
         :height="height"
         viewBox="0 0 19 24"
         fill="none">
      <path d="M17 13.5C17.8284 13.5 18.5 12.8284 18.5 12C18.5 11.1716 17.8284 10.5 17 10.5V13.5ZM0.939339 10.9393C0.353552 11.5251 0.353552 12.4749 0.939339 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97919 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.939339 10.9393ZM17 10.5L2 10.5V13.5L17 13.5V10.5Z"
            fill="black"/>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'ArrowBackIcon',
  props: {
    width: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 18
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }

}
</script>

<style>
.contentIconBack{
  background-color: #00ffdc;
  border-radius: 25px;
  height: 35px !important;
  width: 35px !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ComissionsContainer__display--elipse{
  .contentIconBack{
    border-radius: 40px;
    width: 71px !important;
    height: 71px !important;
}
}
</style>
